import { render, staticRenderFns } from "./ForceLogoutConfirmation.vue?vue&type=template&id=5c53eaba&scoped=true"
import script from "./ForceLogoutConfirmation.vue?vue&type=script&lang=js"
export * from "./ForceLogoutConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ForceLogoutConfirmation.vue?vue&type=style&index=0&id=5c53eaba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53eaba",
  null
  
)

export default component.exports